import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

import { Button, Input } from "../../../../../../../../../components/Form";
import { MapStatus } from "../../../../../../../../../util/enums";

const getSquareBackgroundColor = (status?: string) => {
  switch (status?.toLowerCase()) {
    case MapStatus.EMPTY.toLowerCase():
      return "#CCDEEE";
    case MapStatus.LOADED.toLowerCase():
      return "#53B1FD";
    case MapStatus.MIXED.toLowerCase():
      return "#FAA7E0";
    case MapStatus.INACTIVE.toLowerCase():
      return "#98A2B3";
    default:
      return "#CCDEEE";
  }
};

export const MapSquare = styled("div")(({ status }: { status?: string }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  maxWidth: "2rem",
  maxHeight: "2rem",
  borderRadius: "1px",
  background: getSquareBackgroundColor(status),
  marginBottom: "0.5rem",
  "& button": {
    "& span": {
      display: "none",
    },
  },
}));

export const MapInput = styled(Input, {
  shouldForwardProp: (props) => props !== "isViewMode",
})(({ isViewMode }: { isViewMode: boolean }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  height: "2rem",
  width: "2rem",
  alignItems: "center",
  borderRadius: "4px",
  background: "#FFF",
  "& > div > fieldset": {
    borderRadius: "4px",
    border: isViewMode ? "none" : "1px solid #E4E7EC",
  },
  "& > div > input": {
    padding: 0,
    color: "#308CDB",
    fontSize: "16px",
    fontFamily: "Manrope",
    fontWeight: 700,
    lineHeight: "150%",
    textAlign: "center",
  },
}));

export const BlankSquare = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  minHeight: "2rem",
  minWidth: "2rem",
  borderRadius: "1px",
  background: "#FFFFFF",
  marginBottom: "8px",
  opacity: 0,
}));

export const MapRow = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  gap: "0.5rem",
  "& > .MuiFormControl-root": {
    minWidth: "2rem",
    minHeight: "2rem",
  },
}));

export const CellButton = styled(Button)(() => ({
  minWidth: "2rem",
  padding: "0.5rem 1.25rem",
}));

export const MapCellsContainer = styled(Grid, {
  shouldForwardProp: (props) => props !== "isCreate",
})(({ isCreate }: { isCreate: boolean }) => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "stretch",
  maxHeight: isCreate ? "50vh" : "25vh",
  overflow: "auto",
}));

export const TopViewText = styled("span")(() => ({
  color: "#465869",
  fontSize: "12px",
  fontFamily: "Manrope",
  fontWeight: 500,
  lineHeight: "160%",
}));

export const MapWrapper = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  paddingTop: "0.5rem",
}));

export const SkeletonWrapper = styled("div")(() => ({
  height: "200px",
  width: "420px",
}));

export const useStyles = makeStyles(() => ({
  skeleton: {
    height: "200px !important",
  },
}));
